import { actionTypes } from "../actions/MlLicTrackActions";
import { SortTypes } from "../../util/table-view/TableTypes";
import { defaultResultsPerPage, pagingTotalRelation } from "../Types";

const initialState = {
  items: [],
  totalItems: 0,
  totalRelation: pagingTotalRelation.EQUALS,
  selectedItem: {},
  selectedItems: [],
  loading: false,
  loadingMore: false,
  posting: { busy: false, message: "", errors: null },
  editing: null,
  noMore: true,
  postUpdating: false,
  query: {
    inbox: false,
    order: SortTypes.desc,
    orderBy: "updatedAt",
    page: 0,
    size: defaultResultsPerPage,
    q: "",
    filters: [],
  },
  errors: null,
  lastRefreshed: 0,
};

export default function (state = initialState, action) {

  switch (action.type) {
    case actionTypes.LOADING:
      return {
        ...state,
        loading: true,
        loadingMore: false,
        errors: null,
        selectedItems: [],
        items: [],
      };

    case actionTypes.LOAD:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        errors: null,
        items: action.payload.items,
        totalItems: action.payload.total,
        totalRelation: action.payload.totalRelation,
        selectedItem: (action.payload.items && action.payload.items.length > 0) ? action.payload.items[0] : {},
        selectedItems: [],
        postUpdating: action.payload.postUpdating ? true : false,
        noMore: false,
      };

    case actionTypes.POST_UPDATE:
      return {
        ...state,
        items: action.payload.items,
        postUpdating: false,
      };

    case actionTypes.ERROR:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        errors: action.payload,
        items: [],
        totalItems: 0,
        totalRelation: pagingTotalRelation.EQUALS,
        noMore: true,
      };

    case actionTypes.SELECT_ITEMS:
      return {
        ...state,
        selectedItems: action.payload,
      };
    case actionTypes.QUERY:
      return {
        ...state,
        query: action.payload,
      };
    case actionTypes.FOCUS_ITEM:
      return {
        ...state,
        selectedItem: action.payload,
      };
    case actionTypes.REFRESH_ITEMS:
      return {
        ...state,
        items: action.payload,
      };
    case actionTypes.EDIT_ITEM:
      return {
        ...state,
        editing: action.payload,
      };

    case actionTypes.POSTING:
      return {
        ...state,
        posting: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };

    case actionTypes.POST_OK:
      return {
        ...state,
        posting: {
          busy: false,
          message: "",
          errors: null,
        },
      };

    case actionTypes.POST_ERROR:
      return {
        ...state,
        posting: {
          busy: false,
          message: "",
          errors: action.payload,
        },
      };
    case actionTypes.UPDATE_PRS_DATA:
      let OListitems = state.items.map(item =>
        item.trackDetails.id == action.id ? { ...item, trackDetails:{...item.trackDetails , prsTrack: action.payload} } : item
      );
      // console.log("Oitems", Oitems, action,Oitems.filter(e => e.id == action.id)[0]);
      return {
        ...state,
        items: OListitems,
        selectedItem: (OListitems.length > 0) ? OListitems.filter(e => e.trackDetails.id == action.id)[0] : {},
      };

    case actionTypes.LAST_REFRESH:
      return {
        ...state,
        lastRefreshed: action.payload,
      };

    default:
      return state;
  }
}
